import { navBarTemplate } from './nav-bar.template';
import { navBarStyles } from './nav-bar.styles';
import { attr, FASTElement, Observable, observable } from '@microsoft/fast-element';
import { MediaSize, MediaSizeMixin, mediaSizes } from '../../utilities/media-size-observer';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { brand, fillColor, getToken } from '../../design-tokens';
import { DesignToken, DesignTokenChangeRecord, DesignTokenSubscriber } from '../../foundation/design-token';
import { backgroundColorContext } from '../../context/background-context';
import { isDark } from '../../utilities/is-dark';
import { Swatch } from '../../color';

/**
 * @element natgen-nav-bar
 */
export class NatGenNavBar extends MediaSizeMixin(FASTElement) implements DesignTokenSubscriber<DesignToken<any>> {
    @attr({mode: 'boolean', attribute: 'no-collapse' }) noCollapse = false;
    @attr({mode: 'boolean', attribute: 'container' }) useContainer = false;
    @attr breakpoint: MediaSize = 'large';

    @observable expand = false;

    // TODO: This feels a bit hacky, design better tokens for this scenario.
    get borderStyle(): string {
        Observable.track(this, 'brand');
        return `background: ${(getToken('ui-nav-bar-color-border').getValueFor(this) as Swatch)?.toColorString()} no-repeat url('${process.env.ASSET_PATH ? process.env.ASSET_PATH : ''}branding/${getToken('ui-nav-bar-color-border-image').getValueFor(this)}');`
    }

    isExpanded(): boolean {
        return this.expand || this.noCollapse;
    }

    breakpointChanged() {
        this.expand = mediaSizes.indexOf(this.mediaSize) >= mediaSizes.indexOf(this.breakpoint);
    }

    mediaSizeChanged() {
        this.breakpointChanged();
    }

    connectedCallback(): void {
        super.connectedCallback();

        var backgroundToken = getToken('ui-nav-bar-color-background');
        fillColor.setValueFor(this, backgroundToken);
        backgroundColorContext.provide(this, isDark(backgroundToken.getValueFor(this)));
        brand.subscribe(this);
    }

    handleChange(token: DesignToken<any>, record: DesignTokenChangeRecord<DesignToken<any>>): void {
        Observable.notify(this, 'brand');
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        brand.unsubscribe(this);
    }
}

export const natGenNavbarDefinition = NatGenNavBar.compose({
    name: `${NatGenDesignSystem.prefix}-nav-bar`,
    template: navBarTemplate,
    styles: navBarStyles
});
